"use strict";

import angular from "angular";

import template from "./tables-pagination-kpi.component.html";
import "./themes/tables-pagination-kpi.component.scss";
import "./themes/tables-pagination-kpi.component-dark.scss";

class TablesPaginationKpiComponent {
    constructor() {}

    $onInit() {
        this.index = 0;
    }

    /**
     * @public
     * Metodo responsavel pela troca de segmento do componente
     * @param {String} direction
     */
    onChangeTypeFilter(direction) {
        if (direction === "next") {
            if (this.index >= this.tables.length - 1) this.index = 0;
            else this.index++;
        }

        if (direction === "back")
            if (this.index <= 0) this.index = this.tables.length - 1;
            else this.index--;

        if (this.onChangePage)
            this.onChangePage({ tableId: this.tables[this.index]._id });
    }
}

export { TablesPaginationKpiComponent };

TablesPaginationKpiComponent.$inject = [];

const name = "tablesPaginationKpiComponent";
const def = {
    bindings: {
            tables: "=",
            onChangePage: "&"
        },
        controller: TablesPaginationKpiComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
